module.exports = __webpack_public_path__ + "static/media/document.5e17aea0.png";